<template>
  <div id="app">
    <!-- <meta name="referrer" content="no-referrer" /> -->
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
}
body{
  margin: 0;
  padding:0;
  font: 15px "Microsoft YaHei", Arial, Helvetica, sans-serif;
  background-size: cover !important;
  background: url('./assets/images/bg.jpg') no-repeat top center;
  background-attachment: fixed;
  height: 100%;
}
a {
  text-decoration: none;
  color: #000000;
}
.router-link-active {
  text-decoration: none;
}
</style>
